module.exports = __webpack_public_path__ + "img/cssy.c27c158c.jpg";